import type { Theme } from '@mui/material';

export const getButtonInteractionStyles = (theme: Theme) => ({
  '&:hover': { backgroundColor: theme.palette.button.hover },
  '&:active': { backgroundColor: theme.palette.button.pressed },
});
